import React, { useState, useCallback } from "react";
import "./accountlayout.css";
import Cropper, { Area } from "react-easy-crop";
import { Modal } from "react-bootstrap";
import getCroppedImg from "../../utils/getCroppedImg";

import Profile from "../../components/accounts/AccountProfile/AccountProfile";
import ApplicantsList from "../../components/accounts/ApplicantsList/ApplicantsList";
import MyOrders from "../../components/Myorders/MyOrders";
import OrderDetails from "../../components/Myorders/OrderDetails/OrderDetails";
import Applicants from "../../components/Myorders/applicants/Applicants";
import OrderFaq from "../../components/Myorders/orderFaqs/OrderFaq";
import AddressListing from "../../components/accounts/AddressListing/AddressListing";

type AccountLayoutProps = {
  avatar?: string | null;
  onUpdate?: (avatar: string) => void;
};

const AccountLayout: React.FC<AccountLayoutProps> = ({
  avatar: initialAvatar,
  onUpdate,
}) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(
    initialAvatar || null
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result as string);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const onCropComplete = useCallback((_: any, area: Area) => {
    setCroppedAreaPixels(area);
  }, []);

  const handleCropDone = async () => {
    if (!selectedImage || !croppedAreaPixels) return;

    try {
      const croppedImage = await getCroppedImg(
        selectedImage,
        croppedAreaPixels
      );
      const file = new File([croppedImage], "profile.jpg", {
        type: "image/jpeg",
      });
      setAvatarUrl(URL.createObjectURL(file)); // for preview
      setIsModalOpen(false);
      setShowSuccessModal(true); // show the success modal
      if (onUpdate) onUpdate(URL.createObjectURL(file));
    } catch (error) {
      console.error("Cropping failed", error);
    }
  };

  const [showSupportModal, setShowSupportModal] = useState(false);

  const handleOpenSupportModal = () => setShowSupportModal(true);
  const handleCloseSupportModal = () => setShowSupportModal(false);
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-auto col-12 p-0">
          <div
            className="sidebar-account"
            style={{ position: "sticky", top: "100px", zIndex: 1 }}
          >
            {/* Avatar block */}
            <div className="mb-3 mb-md-4 d-flex mx-3 mx-md-0 align-items-center gap-2 bg-main bg-sm-3 p-3  rounded-3 text-white position-relative">
              <div className="position-relative">
                <img
                  src={
                    avatarUrl ||
                    "https://randomuser.me/api/portraits/men/75.jpg"
                  }
                  className="avatar-preview mb-2 rounded-circle"
                  alt="Profile"
                  style={{ width: "64px", height: "64px", objectFit: "cover" }}
                />
                <div
                  className="edit-icon"
                  onClick={() =>
                    document.getElementById("profile-file-input")?.click()
                  }
                >
                  <img
                    src="https://goodhand.b-cdn.net/Assets/Flow/edit-icon.svg"
                    alt="Edit"
                  />
                  <input
                    type="file"
                    accept="image/*"
                    id="profile-file-input"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
              </div>
              <div>
                <h6 className="mb-0 ff-semibold">John Wick</h6>
                <small className="ff-medium">iamjohnwirk@gmail.com</small>
              </div>
            </div>

            {/* Modal for cropping */}
            <Modal
              show={isModalOpen}
              onHide={() => setIsModalOpen(false)}
              backdrop="static"
              centered
              className="profile-pic"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body className="modal-dialog-scrollable rounded-top modal-body">
                <div>
                  <p className="font-16 ff-semibold text-center text-black border-bottom pb-2">
                    UPLOAD PHOTO
                  </p>
                </div>

                <div className="cropper-wrapper">
                  <div
                    style={{ position: "relative", width: "100%", height: 310 }}
                    className="rounded"
                  >
                    <Cropper
                      image={selectedImage || ""}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />

                    <div className="zoom-controls">
                      <button
                        onClick={() => setZoom(zoom - 0.1)}
                        className="zoom-btn"
                      >
                        −
                      </button>
                      <div className="divider" />
                      <button
                        onClick={() => setZoom(zoom + 0.1)}
                        className="zoom-btn"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className="p-0 border-0 rounded-0 shadow-none  modal-foote justify-content-center">
                <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
                  <button
                    onClick={handleCropDone}
                    className="btn btn-primary w-100 font-14 ff-semibold py-3  bt--cart"
                  >
                    Proceed
                  </button>
                </div>
              </Modal.Footer>
            </Modal>

            <Modal
              show={showSuccessModal}
              onHide={() => setShowSuccessModal(false)}
              centered
            >
              {" "}
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body className="rounded-top text-center">
                <img
                  src="https://goodhand.b-cdn.net/Assets/Flow/image-sucsess.png" // Replace with your icon path
                  alt="Success"
                />
                <h6 className="mb-3">Profile updated successfully</h6>
              </Modal.Body>
              <Modal.Footer className="p-0 border-0 rounded-0 shadow-none  modal-foote border-top rounded-bottom justify-content-center">
                <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
                  <button
                    onClick={() => setShowSuccessModal(false)}
                    className="btn btn-primary w-100 font-14 ff-semibold py-3  bt--cart"
                  >
                    OkAY, GOT IT
                  </button>
                </div>
              </Modal.Footer>
            </Modal>

            {/* Sidebar content */}
            <div className="sidebar-content-wrap">
              <div className="nav-section mb-3">
                <div className="p-md-3 p-0 layout-border rounded">
                  <p className="font-14 text-muted px-md-0 px-3 nav-cat py-2 py-md-0 nav-mob-heading ">
                    My Account
                  </p>
                  <div className="nav-item dash active bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="20"
                        viewBox="0 0 17 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 5C3 6.06087 3.42143 7.07829 4.17157 7.82843C4.92172 8.57858 5.93913 9.00001 7 9.00001C8.06087 9.00001 9.07828 8.57858 9.82843 7.82843C10.5786 7.07829 11 6.06087 11 5C11 3.93914 10.5786 2.92172 9.82843 2.17157C9.07828 1.42143 8.06087 1 7 1C5.93913 1 4.92172 1.42143 4.17157 2.17157C3.42143 2.92172 3 3.93914 3 5Z"
                          stroke="#000"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 19V17C1 15.9391 1.42143 14.9217 2.17157 14.1716C2.92172 13.4214 3.93913 13 5 13H9"
                          stroke="#000"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10 17L12 19L16 15"
                          stroke="#000"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14">Profile</div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="nav-item dash bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.66406 4.33333C2.66406 5.21739 3.01525 6.06523 3.64037 6.69036C4.26549 7.31548 5.11334 7.66667 5.9974 7.66667C6.88145 7.66667 7.7293 7.31548 8.35442 6.69036C8.97954 6.06523 9.33073 5.21739 9.33073 4.33333C9.33073 3.44928 8.97954 2.60143 8.35442 1.97631C7.7293 1.35119 6.88145 1 5.9974 1C5.11334 1 4.26549 1.35119 3.64037 1.97631C3.01525 2.60143 2.66406 3.44928 2.66406 4.33333Z"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 16V14.3333C1 13.4493 1.35119 12.6014 1.97631 11.9763C2.60143 11.3512 3.44928 11 4.33333 11H7.66667C8.55072 11 9.39857 11.3512 10.0237 11.9763C10.6488 12.6014 11 13.4493 11 14.3333V16"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.8359 1.10742C12.553 1.29101 13.1885 1.70801 13.6423 2.29268C14.0961 2.87736 14.3425 3.59645 14.3425 4.33659C14.3425 5.07673 14.0961 5.79582 13.6423 6.3805C13.1885 6.96517 12.553 7.38217 11.8359 7.56576"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16 16V14.3333C15.9958 13.5976 15.7483 12.884 15.2961 12.3037C14.8439 11.7233 14.2124 11.3089 13.5 11.125"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14 text-black">
                      Applicants
                    </div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nav-section mb-3">
                <div className="p-md-3 p-0 layout-border rounded">
                  <p className="font-14 text-muted px-md-0 px-3 nav-cat py-2 py-md-0 nav-mob-heading ">
                    My Orders
                  </p>
                  <div className="nav-item dash  bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 6.83398C6 7.49703 6.26339 8.13291 6.73223 8.60175C7.20107 9.07059 7.83696 9.33398 8.5 9.33398C9.16304 9.33398 9.79893 9.07059 10.2678 8.60175C10.7366 8.13291 11 7.49703 11 6.83398C11 6.17094 10.7366 5.53506 10.2678 5.06622C9.79893 4.59738 9.16304 4.33398 8.5 4.33398C7.83696 4.33398 7.20107 4.59738 6.73223 5.06622C6.26339 5.53506 6 6.17094 6 6.83398Z"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.5 16.0007V15.1673C3.5 14.2833 3.85119 13.4354 4.47631 12.8103C5.10143 12.1852 5.94928 11.834 6.83333 11.834H10.1667C11.0507 11.834 11.8986 12.1852 12.5237 12.8103C13.1488 13.4354 13.5 14.2833 13.5 15.1673V16.0007"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 2.66667C1 2.22464 1.17559 1.80072 1.48816 1.48816C1.80072 1.17559 2.22464 1 2.66667 1H14.3333C14.7754 1 15.1993 1.17559 15.5118 1.48816C15.8244 1.80072 16 2.22464 16 2.66667V14.3333C16 14.7754 15.8244 15.1993 15.5118 15.5118C15.1993 15.8244 14.7754 16 14.3333 16H2.66667C2.22464 16 1.80072 15.8244 1.48816 15.5118C1.17559 15.1993 1 14.7754 1 14.3333V2.66667Z"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14">My Orders</div>
                  </div>
                  <div className="nav-item dash bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="15"
                        viewBox="0 0 17 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.17969 8.94152C7.17969 9.87758 7.55154 10.7753 8.21343 11.4372C8.87532 12.0991 9.77304 12.4709 10.7091 12.4709C11.6452 12.4709 12.5429 12.0991 13.2048 11.4372C13.8667 10.7753 14.2385 9.87758 14.2385 8.94152C14.2385 8.00546 13.8667 7.10774 13.2048 6.44585C12.5429 5.78396 11.6452 5.41211 10.7091 5.41211C9.77304 5.41211 8.87532 5.78396 8.21343 6.44585C7.55154 7.10774 7.17969 8.00546 7.17969 8.94152Z"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.7969 12.0293L16.0028 14.2352"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 1H15.1176"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 6.29492H4.52941"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 11.5879H4.52941"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14 text-black">
                      Track Orders
                    </div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="nav-item dash bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10526 12.289H3.36842C2.74028 12.289 2.13786 12.0394 1.69369 11.5953C1.24953 11.1511 1 10.5487 1 9.92054V3.60475C1 2.9766 1.24953 2.37419 1.69369 1.93002C2.13786 1.48586 2.74028 1.23633 3.36842 1.23633H12.8421C13.4703 1.23633 14.0727 1.48586 14.5168 1.93002C14.961 2.37419 15.2105 2.9766 15.2105 3.60475V7.15738"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 5.18359H15.2105"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.2656 12.2891H16.0025"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.6328 9.91992L16.0012 12.2883L13.6328 14.6568"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.16406 9.13086H4.16801"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.3125 9.13086H8.89145"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14 text-black">Payments</div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nav-section mb-3">
                <div className="p-md-3 p-0 layout-border rounded">
                  <p className="font-14 text-muted px-md-0 px-3 nav-cat py-2 py-md-0 nav-mob-heading ">
                    Support
                  </p>
                  <div className="nav-item dash  bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.33594 5.71159C5.33594 6.28622 5.56421 6.83732 5.97054 7.24365C6.37687 7.64998 6.92797 7.87825 7.5026 7.87825C8.07724 7.87825 8.62834 7.64998 9.03467 7.24365C9.441 6.83732 9.66927 6.28622 9.66927 5.71159C9.66927 5.13695 9.441 4.58585 9.03467 4.17952C8.62834 3.7732 8.07724 3.54492 7.5026 3.54492C6.92797 3.54492 6.37687 3.7732 5.97054 4.17952C5.56421 4.58585 5.33594 5.13695 5.33594 5.71159Z"
                          stroke="#282828"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.16406 13.656V12.9338C3.16406 12.1676 3.46843 11.4328 4.0102 10.8911C4.55197 10.3493 5.28677 10.0449 6.05295 10.0449H8.94184C9.70802 10.0449 10.4428 10.3493 10.9846 10.8911C11.5264 11.4328 11.8307 12.1676 11.8307 12.9338V13.656"
                          stroke="#282828"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 2.10069C1 1.7176 1.15218 1.3502 1.42307 1.07932C1.69395 0.808432 2.06135 0.65625 2.44444 0.65625H12.5556C12.9386 0.65625 13.306 0.808432 13.5769 1.07932C13.8478 1.3502 14 1.7176 14 2.10069V12.2118C14 12.5949 13.8478 12.9623 13.5769 13.2332C13.306 13.5041 12.9386 13.6562 12.5556 13.6562H2.44444C2.06135 13.6562 1.69395 13.5041 1.42307 13.2332C1.15218 12.9623 1 12.5949 1 12.2118V2.10069Z"
                          stroke="#282828"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14">Need Help</div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="nav-item dash bg-2 d-flex align-items-center gap-2 py-2">
                    <div>
                      <svg
                        width="17"
                        height="15"
                        viewBox="0 0 17 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.17969 8.94152C7.17969 9.87758 7.55154 10.7753 8.21343 11.4372C8.87532 12.0991 9.77304 12.4709 10.7091 12.4709C11.6452 12.4709 12.5429 12.0991 13.2048 11.4372C13.8667 10.7753 14.2385 9.87758 14.2385 8.94152C14.2385 8.00546 13.8667 7.10774 13.2048 6.44585C12.5429 5.78396 11.6452 5.41211 10.7091 5.41211C9.77304 5.41211 8.87532 5.78396 8.21343 6.44585C7.55154 7.10774 7.17969 8.00546 7.17969 8.94152Z"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.7969 12.0293L16.0028 14.2352"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 1H15.1176"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 6.29492H4.52941"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 11.5879H4.52941"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14 text-black">FAQ's</div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="nav-item dash bg-2 d-flex align-items-center gap-2 py-2"
                    onClick={handleOpenSupportModal}
                  >
                    <div>
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10526 12.289H3.36842C2.74028 12.289 2.13786 12.0394 1.69369 11.5953C1.24953 11.1511 1 10.5487 1 9.92054V3.60475C1 2.9766 1.24953 2.37419 1.69369 1.93002C2.13786 1.48586 2.74028 1.23633 3.36842 1.23633H12.8421C13.4703 1.23633 14.0727 1.48586 14.5168 1.93002C14.961 2.37419 15.2105 2.9766 15.2105 3.60475V7.15738"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 5.18359H15.2105"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.2656 12.2891H16.0025"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.6328 9.91992L16.0012 12.2883L13.6328 14.6568"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.16406 9.13086H4.16801"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.3125 9.13086H8.89145"
                          stroke="#282828"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="ff-medium font-14 text-black">
                      24/7 support
                    </div>
                    <div className="d-flex d-md-none flex-grow-1 align-items-center justify-content-end">
                      <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 0.856171L6 5.85617L1 10.8562"
                          stroke="#676767"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                show={showSupportModal}
                onHide={handleCloseSupportModal}
                centered
                backdrop="static"
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="rounded p-0">
                  <p className="font-18 text-center ff-bold text-black py-3 border-bottom">
                    Support 24/7
                  </p>
                  <div className="p-3 layout-border rounded-3 m-3">
                    <div className="d-flex align-items-center gap-3 border-bottom pb-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/phone-24.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        +971 51 234 5678
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 border-bottom py-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/whatsp-24.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        +971 51 234 5678
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 border-bottom py-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/envlp-24.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        Connect with a representative
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 border-bottom py-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/at-24'.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        Support@goodhand.ae
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 border-bottom py-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/facebo-24.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        Facebook
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3  pt-3">
                      <div>
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/camers-24.svg"
                          alt=""
                        />
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        Instagram
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              <div className="nav-section mb-3">
                <div className="nav-item dash bg-2 d-flex align-items-center p-0 gap-2 my-0">
                  <div className="btn logout-btn w-100 mx-3 mx-md-0">
                    <i className="bi bi-box-arrow-right me-2"></i> Logout
                  </div>
                </div>
              </div>
            </div>
            {/* 
            <div className="sidebar-footer mt-3">
              <button className="btn logout-btn w-100">
                <i className="bi bi-box-arrow-right me-2"></i> Logout
              </button>
            </div> */}
          </div>
        </div>

        {/* Main content */}
        <div className="col main-content-account ms-0 ms-md-3 m-0">
          <Profile />
          <Applicants />
          <ApplicantsList />
          <MyOrders />
          <OrderDetails />
          <OrderFaq />
          <AddressListing />
        </div>
      </div>
    </div>
  );
};

export default AccountLayout;
